module.exports = __webpack_public_path__ + "img/Certificate_8.5102bdfc.jpg";